module.exports = __webpack_public_path__ + "kaitak_FV_20210917.a82a8f3828fd85f1ca75.png";